var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPointsIconBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_1315",
    "data-name": "Group 1315",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 21.038,
    height: 21.035,
    viewBox: "0 0 21.038 21.035",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_188",
    "data-name": "Rectangle 188",
    width: 21.038,
    height: 21.035,
    fill: "#5d5d5d"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_598",
    "data-name": "Group 598",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_322",
    "data-name": "Path 322",
    d: "M17.4,21.035H3.641A3.641,3.641,0,0,1,0,17.4V3.641A3.641,3.641,0,0,1,3.641,0H17.4a3.641,3.641,0,0,1,3.641,3.641V17.4A3.641,3.641,0,0,1,17.4,21.035",
    transform: "translate(0 0)",
    fill: "#2a77eb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_323",
    "data-name": "Path 323",
    d: "M130.471,143.48c.074-.333.163-.74.256-1.146.126-.559.248-1.12.384-1.677a.26.26,0,0,0-.1-.3c-.7-.61-1.4-1.228-2.1-1.839a.578.578,0,0,1-.229-.616.546.546,0,0,1,.521-.423l1.552-.143c.45-.041.9-.087,1.348-.119.122-.009.134-.091.174-.169.365-.854.735-1.706,1.093-2.564a.575.575,0,0,1,1.111,0c.359.856.729,1.709,1.091,2.565a.241.241,0,0,0,.236.174c.919.075,1.839.161,2.758.248.416.039.641.268.621.616a.613.613,0,0,1-.246.432c-.669.582-1.321,1.172-2,1.74a.463.463,0,0,0-.179.535c.211.855.4,1.714.6,2.573a.579.579,0,0,1-.442.769.63.63,0,0,1-.463-.123c-.787-.471-1.574-.937-2.357-1.416a.288.288,0,0,0-.348,0c-.794.483-1.6.956-2.393,1.435a.566.566,0,0,1-.89-.558",
    transform: "translate(-123.409 -128.583)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPointsIconBlue);
export default __webpack_public_path__ + "static/media/points_icon_blue.efc847852f644d5428ae031ffb72b3ec.svg";
export { ForwardRef as ReactComponent };